import { render, staticRenderFns } from "./FileCategories.vue?vue&type=template&id=309589d5&"
import script from "./FileCategories.vue?vue&type=script&lang=js&"
export * from "./FileCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QTable,QInput,QIcon,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QTable,QInput,QIcon,QTd})
